import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiWoSinistriWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'wo-sinistri-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/work-orders/sinistri/count')
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="OdL sinistri aperti"
      value={data}
      loading={isLoading}
      color="#fa8c16"
      onClick={() => navigate('/schede-lavoro?sinistro=true')}
    />
  )
}
